module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/core/soundcloud-905c7c3d0791b2a4ece0fcbf2f5ff232.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/core/soundcloud.svg
// module id = ftbc
// module chunks = 24